import { render, staticRenderFns } from "./NapTransferCampaigns.vue?vue&type=template&id=88411e6a&scoped=true&"
import script from "./NapTransferCampaigns.vue?vue&type=script&lang=js&"
export * from "./NapTransferCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88411e6a",
  null
  
)

export default component.exports